const executeKey = {
  not: "not"
  ,doing: "doing"
  ,success: "success"
  ,warning: "warning"
  ,error: "error"
}
export default executeKey



// WEBPACK FOOTER //
// ./src/cnConst/executeKey.js